import { RevisarCadastro } from "./RevisarCadastro";

export default RevisarCadastro;